import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=efb37c80&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=efb37c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb37c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efb37c80')) {
      api.createRecord('efb37c80', component.options)
    } else {
      api.reload('efb37c80', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=efb37c80&scoped=true&", function () {
      api.rerender('efb37c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BWpTzN664qrW/JS/comp/PopupDialog.vue"
export default component.exports